import * as React from "react";

import {
  Button,
  Container,
  FormControl,
  FormHelperText,
  Heading,
  Input,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";

export const NewsLetter = ({ heading, buttonText, text, input, href }: any) => (
  <Container
    maxW={{ base: "3xl", md: "7xl" }}
    py={{ base: "0", md: "16" }}
    px={0}
  >
    <Stack
      direction={{ base: "column", lg: "row" }}
      justify="space-between"
      bg={"#49A3CB"}
      py={14}
      px={{ base: "4", md: "7.5rem" }}
      alignItems={"center"}
    >
      <Stack flex={1} maxW={"490px"} gap={{ base: "4", md: "0" }}>
        <Heading
          fontSize={"4xl"}
          textTransform={"uppercase"}
          fontFamily={"TradeGothic LT Bold"}
          fontWeight={"700"}
          lineHeight={"115%"}
          color={"white"}
          textAlign={{ base: "center", md: "left" }}
        >
          {heading}
        </Heading>
        <Text
          color={"white"}
          textAlign={{ base: "center", md: "left" }}
          pb={{ base: "8", md: "0" }}
          fontSize={"md"}
        >
          {text}
        </Text>
      </Stack>
      <Stack
        flex={1}
        direction={{ base: "column", md: "row" }}
        spacing="24px"
        width="full"
        justifyContent={"flex-end"}
      >
        {input ? (
          <FormControl flex="1">
            <Input
              type="email"
              border={"none"}
              size="xl"
              bg={"white"}
              color={"#929E95"}
              px={4}
              py={3}
              placeholder="Your email"
            />
          </FormControl>
        ) : (
          <></>
        )}
        <Link display="flex" justifyContent="center" href={href} _hover={{ textDecoration: "none" }}>
          <Button
            variant="solid"
            color={"white"}
            px={8}
            h={12}
            textTransform={"uppercase"}
            borderRadius={0}
            fontWeight={"700"}
            aria-label="newsletter"
          >
            {buttonText}
          </Button>
        </Link>
      </Stack>
    </Stack>
  </Container>
);
